import {createFileRoute} from '@tanstack/react-router';

import {SettingsSearchParams} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {ProjectSettings} from '~components/settings/ProjectSettings';
import {ProjectSettingsTabs} from '~components/settings/ProjectSettingsTab';

export const Route = createFileRoute('/settings/shifts')({
  component: SettingsShiftsPage,
  validateSearch: SettingsSearchParams.validate,
});

function SettingsShiftsPage(): JSX.Element {
  return (
    <BaseLayout>
      <ProjectSettings tabName={ProjectSettingsTabs.Shifts} />
    </BaseLayout>
  );
}
